var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }